import { clearPendingSegment, clearRegistrationAttempt, registrationForUser } from '../../product-segment'
import { useDraftStore } from './draftStore'
import { useOnboardingStore } from '../../../store/onboardingStore'
import { clearOnboardingVariant } from './onboardingVariant'

export function acceptAuthenticatedDraft(userId: string) {
  const attempt = registrationForUser(userId)
  const draft = attempt?.draft
  useDraftStore.setState({ draft: draft ? { ...draft, ownerUserId: userId } : null })
  useOnboardingStore.getState().clearPending()
  clearPendingSegment()
  clearOnboardingVariant()
  clearRegistrationAttempt()
}
export function discardGuestDraft() {
  clearOnboardingVariant()
  useDraftStore.getState().clear()
  useOnboardingStore.getState().clearPending()
  clearRegistrationAttempt()
}
